import { faker } from '@faker-js/faker';

const artefact = {
  document_type: 'rg',
  front: {
    filename: 'documento da biometria facial - frente - 11 mai 2024, 17-26-00.',
    image_url: faker.image.urlPlaceholder(),
  },
  back: {
    filename: 'documento da biometria facial - verso - 11 mai 2024, 17-26-23.',
    image_url: faker.image.urlPlaceholder(),
  },
  selfie: {
    filename: 'foto da biometria facial - selfie - 11 mai 2024, 17-26-45.',
    image_url: faker.image.urlPlaceholder(),
  },
};

export function fillEvidence(artefacted: boolean) {
  return {
    key: faker.string.uuid(),
    state: 'done',
    role: 'sign',
    artefact: artefacted ? artefact : null,
  };
}

export function step(auth: string) {
  const agreeAuthData = auth === 'agree' && {
    document_key: faker.string.uuid(),
    role: 'sign',
  };

  return {
    step: {
      requirements: [
        {
          key: faker.string.uuid(),
          filled: false,
          evidence_key: null,
          auth,
          ...agreeAuthData,
        },
      ],
      evidences: [],
    },
  };
}

export const steps = {
  all: ['facial_biometrics'],
  finished: [],
};
